// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1y-qT","inputDescription":"styles_inputDescription__ogCWg"};